import { ReactComponent as SearchQuoteIcon } from "duck/ui/components/DuckLogo/quote-search.svg";
import { useTranslation } from "react-i18next";

const RoomForImprovementBanner = () => {
  const { t } = useTranslation("duck");

  return (
    <div className="flex items-center space-x-2 bg-amber-100 p-2 rounded-lg text-xs">
      <SearchQuoteIcon color="yellow" />
      <span>{t("room_for_improvement")}</span>
    </div>
  );
};

export default RoomForImprovementBanner;
